import React from "react";
import SectionHeader from "./SectionHeader";
import Select from "../util/Select";
import Input from "../util/Input";
import MulSelectCreatable from "../util/MulSelectCreatable";
import { PropTypes } from "prop-types";


const Environment = props => {
  if (props.productFamily && props.productFamily.toUpperCase()==="OMNIVERSE") {
    if(props.isBoxx)
    {
      return  (
        <div className="AppSection">
          <SectionHeader title={"Environment"} />
          <div className={"leftColumn"}>
            <Select
              labelText={"Certified System"}
              optionValues={props.BoxxCertifiedSystemOptions}
              isRequired={true}
              onChange={props.handleCertfiiedSystemChange}
            />
            
            {/* <Select
  
              labelText={"Deployment"}
              isVMWare={false}
              optionValues={props.BoxxDeploymentOptions}
              isRequired={true}
              onChange={props.handleBoxDeployment}
            /> */}
              
              <Select
              labelText={"NVIDIA GPUs"}
              optionValues={props.BoxxNvidiaGPUOptions}
              isRequired={true}
              onChange={props.handleBoxxNvidiaGPUChange}
            />  
             <Select
          labelText={"Deployment Type"}
          optionValues={props.BoxxDeploymentTypeOptions}
          isRequired={true}
          onChange={props.handleBoxDeploymentTypeChange}
                  />
          </div>
        
        
             
        </div>
      );
    }
    return  (
      <div className="AppSection">
        <SectionHeader title={"Environment"} />
        <div className={"leftColumn"}>
          <Select
            labelText={"NVIDIA GPUs Deployed"}
            optionValues={props.NvidiaGpusDeployedOptions}
            isRequired={true}
            onChange={props.handleGPUDeployed}
          />
          
          <Select
            labelText={"Deployment"}
            optionValues={props.deploymentOptions}
            isRequired={true}
            onChange={props.handleDeployment}
          />
            
           { <MulSelectCreatable labelText={"Primary Application"}
            optionValues={props.primaryAppOptions}
            isRequired={true}
            onChange={props.handlePrimaryAppChange}></MulSelectCreatable> }
        </div>
        <div className={"leftColumn"}>
        <Select
            labelText={"UseCase"}
            optionValues={props.useCaseOptions}
            isRequired={true}
            onChange={props.handleUseCaseOptions}
          />
          <Select
            labelText={"Estimated Number Of Users"}
            optionValues={props.estimatedUserOptions}
            isRequired={true}
            onChange={props.handleEstimatedUsersOptions}
          />  
    
        
            <div>
       <Input className={'otherMargin'}
          labelText={"Other Applications"}
          isRequired={false}
          value={props.otherApplicationsVal}      
          disabled={false}
          readOnly={false}
          onChange={props.handleOtherValChange}
          maximumLength={160}
        />
        </div>
            </div>
           
      </div>
    );
  }
 else if (props.productFamily && props.productFamily.toUpperCase()==="NVAIE") {
    return  (
      <div className="AppSection">
        <SectionHeader title={"Environment"} />
        <div className={"leftColumn"}>
          <Select
            labelText={"Compatible Hardware"}
            optionValues={props.CompatibleHardwareOptions}
            isRequired={true}
            onChange={props.handleCompatibleHardwareChange}
          />
          
          <Select

            labelText={"VMware vSphere 7 U2 Enterprise Edition or later"}
            isVMWare={true}
            optionValues={props.VMWareOptions}
            isRequired={true}
            onChange={props.handleVMWareChange}
          />
            
            <Select
            labelText={"Estimated Number Of Users"}
            optionValues={props.estimatedUserOptions}
            isRequired={true}
            onChange={props.handleEstimatedUsersOptions}
          />  
        </div>
        
           
      </div>
    );
  }
  else if (props.productFamily && props.productFamily.toUpperCase()==="PARTNEROMNIVERSE") {
  
    
    return  (
      <div className="AppSection">
        <SectionHeader title={"Environment"} />
        <div className={"leftColumn"}>
          <Select
            labelText={"Certified System"}
            optionValues={props.PartnerCertifiedOptions}
            isRequired={true}
            onChange={props.handlePartnerCertifiedSystemChange}
          />
          
          <Select

            labelText={"Deployment"}
            isVMWare={false}
            optionValues={props.PartnerDeploymentOptions}
            isRequired={true}
            onChange={props.handlePartnerDeployment}
          />
            
            <Select
            labelText={"NVIDIA GPUs"}
            optionValues={props.PartnerNvidiaGPUOptions}
            isRequired={true}
            onChange={props.handlePartnerNvidiaGPUChange}
          />  
        </div>
        
           
      </div>
    );
  }
 
  return (
    <div className="AppSection">
      <SectionHeader title={"Environment"} />
      <div className={"leftColumn isvgpuClass"}>
        <Select
          labelText={"Certified Server"}
          optionValues={props.serverOptions}
          isRequired={true}
          onChange={props.handleServerChange}
        />
        <Select
          labelText={"VDI Hypervisor"}
          optionValues={props.hypervisorOptions}
          isRequired={true}
          onChange={props.handleHypervisorChange}
        />
        <Select
          labelText={"VDI Seats"}
          optionValues={props.seatOptions}
          isRequired={true}
          onChange={props.handleSeatsChange}
        />
            
            <MulSelectCreatable labelText={"Primary Application"}
          optionValues={props.primaryAppOptions}
          isRequired={true}
          onChange={props.handlePrimaryAppChange}></MulSelectCreatable>
        
      </div>
      <div className={"leftColumn isvgpuClass"}>
        <Select
          labelText={"NVIDIA GPUs"}
          optionValues={props.gpuOptions}
          isRequired={true}
          onChange={props.handleGpuChange}
        />
        <Select
          labelText={"VDI Remoting Client"}
          optionValues={props.remotingOptions}
          isRequired={true}
          onChange={props.handleRemotingChange}
        />
       
       <Input className={'otherMargin'}
          labelText={"Other Applications"}
          isRequired={false}
          value={props.otherApplicationsVal}      
          disabled={false}
          readOnly={false}
          onChange={props.handleOtherValChange}
          maximumLength={160}
        />
         
          </div>
      
    </div>
  );
};

Environment.propTypes = {
  serverOptions: PropTypes.array.isRequired,
  isBoxx:PropTypes.bool,
  hypervisorOptions: PropTypes.array.isRequired,
  seatOptions: PropTypes.array.isRequired,
  gpuOptions: PropTypes.array.isRequired,
  remotingOptions: PropTypes.array.isRequired,
  primaryAppOptions: PropTypes.array.isRequired,
  handleServerChange: PropTypes.func.isRequired,
  handleOtherValChange:PropTypes.func.isRequired,
  handleHypervisorChange: PropTypes.func.isRequired,
  handleSeatsChange: PropTypes.func.isRequired,
  handleGpuChange: PropTypes.func.isRequired,
  handleRemotingChange: PropTypes.func.isRequired,
  handlePrimaryAppChange: PropTypes.func.isRequired,
 // handleBoxDeployment: PropTypes.func.isRequired,
  handleBoxxNvidiaGPUChange: PropTypes.func.isRequired,
  handleBoxDeploymentTypeChange: PropTypes.func.isRequired,
  handleCertfiiedSystemChange: PropTypes.func.isRequired,
  
  boxxDeploymentTypeOptions :PropTypes.array.isRequired,
  //boxxDeploymentOptions:PropTypes.array.isRequired,
  boxxCertifiedSystemOptions:PropTypes.array.isRequired,
  boxxNvidiaGPUOptions:PropTypes.array.isRequired,





};

export default Environment;
